<template>
  <div v-if="!isEmpty(value)" data-cy="workflow-status-list" class="space-y-5">
    <div
      v-for="(workflowStatus, index) in value"
      :key="index"
      class="max-w-40 break-normal whitespace-nowrap"
      :data-cy="`workflow-status-list-${index}`"
    >
      <work-flow-status-cell
        :value="getTitle(workflowStatus)"
        :model="{ workflow_status: workflowStatus }"
      />
    </div>
  </div>
  <div v-else>-</div>
</template>
<script lang="ts" setup>
import isEmpty from "lodash/isEmpty";

import WorkFlowStatusCell from "@/components/ui/table/cell/WorkFlowStatusCell.vue";

import type { WorkflowSnapshotStatus } from "@/models/applications";

const props = withDefaults(
  defineProps<{
    value?: WorkflowSnapshotStatus[];
    statusType: keyof WorkflowSnapshotStatus;
  }>(),
  {
    statusType: "status",
  }
);

const getTitle = (workflowStatus: WorkflowSnapshotStatus) => {
  return !isEmpty(workflowStatus) && !isEmpty(workflowStatus[props.statusType])
    ? String(workflowStatus[props.statusType])
    : "";
};
</script>
